import { SectionBlocks } from '@/widgets/game-section/ui/styles';
import {
  Provider,
  Providers,
  ProvidersWrapper,
} from '@/widgets/game-sections/ui/styles';
import { ProvidersSectionWrapper } from '@/widgets/game-sections/ui/section-providers/styles';
import { SkeletonLoader } from '@/shared/ui/skeleton/skeleton';

const ProvidersSkeleton = () => {
  return (
    <ProvidersSectionWrapper>
      <SectionBlocks>
        <SkeletonLoader width={160} height={24} />
      </SectionBlocks>

      <ProvidersWrapper>
        <Providers>
          {[...Array(10)].map((_, index) => (
            <Provider key={index}>
              <SkeletonLoader width="100%" height="100%" />
            </Provider>
          ))}
        </Providers>
      </ProvidersWrapper>
    </ProvidersSectionWrapper>
  );
};

export { ProvidersSkeleton };
